// Contatti ufficiali: modifica qui e si aggiornano ovunque nel sito.
export const EMAIL = "miloTruffle10@gmail.com";
export const PHONE_LABEL = "+39 335 549 0474";
export const PHONE_HREF = "tel:+393355490474";
export const INSTAGRAM_HANDLE = "milotruffle"; // ⚠️ verifica che sia l'username esatto
export const INSTAGRAM_URL = `https://www.instagram.com/${INSTAGRAM_HANDLE}/`;
export const MAPS_URL =
  "https://maps.app.goo.gl/wCfjE4nRKsbncEGH9?g_st=com.google.maps.preview.copy";
